import {
  actions,
  selContent,
  selCutContent,
  selUploadList,
  setCutStatus,
  setFileStatus,
  checkCompleteUpload,
  setUploadStatus,
} from "./librarySlice";
import * as R from "ramda";
import loaderClient, { clientNoLoader } from "api/reduxLoaderApi";
import uploadService from "api/uploadService";
import { setLoading } from "store/slices";
import {
  FAILEDFILE,
  INITCUT,
  ONPROGRESSFILE,
  ONUPLOAd,
  SUCCESSFILE,
} from "./constants";
import { AXIOSFALIED } from "api/constanst";
import { toast } from "react-toastify";

const {
  setContents,
  setRoute,
  setDrawerContent,
  setTagsInLibrary,
  changeDrawerContent,
  setFileUploadProgerss,
  setDeletedItems,
} = actions;

// The Enroute root has no library document/id of its own in the V2 API — a
// null/undefined `parent` means "Enroute root". This sentinel is only used
// for breadcrumb display (ContainerHeader special-cases title === "root").
const ROOT = { id: null, title: "root" };

const byIsFolder = R.groupBy((content) =>
  content.is_folder ? "folders" : "files"
);

const LIBRARIES_BASE = "/v2/backoffice/libraries";
const TAGS_BASE = "/v2/backoffice/tags";

export const getFolderByIdSetDrawer = (id) => async (dispatch) => {
  const client = loaderClient("get")(`${LIBRARIES_BASE}/${id}`);
  const res = await client({})({});

  if (!res.message) return "";
  return dispatch(changeDrawerContent(res.message));
};

export const getAllTags = () => async (dispatch) => {
  const client = loaderClient("get")(`${TAGS_BASE}?limit=all&sortBy=tag:asc`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setTagsInLibrary(res.message));
};

export const addTagsToFileById = (content, current, data) => async (
  dispatch
) => {
  const client = loaderClient("patch")(`${LIBRARIES_BASE}/${content.id}`);
  const res = await client(data)({});
  if (res.error) return "";
  dispatch(getFolderByIdSetDrawer(content.id));
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const getDeletedItems = (parentContent) => async (dispatch) => {
  const parentId = parentContent && parentContent.id ? parentContent.id : null;
  const query = `is_deleted=true&limit=all${
    parentId ? `&parent=${parentId}` : ""
  }`;
  const client = loaderClient("get")(`${LIBRARIES_BASE}?${query}`);
  const res = await client({})({});
  return dispatch(setDeletedItems(res.message || []));
};

export const getRootFolder = () => async (dispatch) => {
  return dispatch(changeCurFolderByContent(null, 0));
};

export const publishByIds = (ids) => async (dispatch, getState) => {
  const client = loaderClient("post")(`${LIBRARIES_BASE}/publish`);
  const res = await client({ libraryIds: ids, is_published: true })({});
  if (res.error) return "";
  const { current } = selContent(getState());
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const publishAll = () => async (dispatch, getState) => {
  const { files = [], folders = [], current } = selContent(getState());
  const ids = [...folders, ...files]
    .filter((i) => !i.is_published)
    .map((i) => i.id);
  if (!ids.length) return "";
  const client = loaderClient("post")(`${LIBRARIES_BASE}/publish`);
  const res = await client({ libraryIds: ids, is_published: true })({});
  if (res.error) return "";
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const unPublishByContent = (content) => async (dispatch, getState) => {
  const client = loaderClient("post")(`${LIBRARIES_BASE}/publish`);
  const res = await client({ libraryIds: [content.id], is_published: false })(
    {}
  );
  if (res.error) return "";
  const { current } = selContent(getState());
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const changeCurFolderByContent = (content, routeIdx) => async (
  dispatch
) => {
  const parentId = content && content.id ? content.id : null;
  const query = `is_deleted=false&limit=all${
    parentId ? `&parent=${parentId}` : ""
  }`;
  const client = loaderClient("get")(`${LIBRARIES_BASE}?${query}`);
  const res = await client({})({});
  if (!res.message) return "";

  const contents = res.message;
  const dividedContents = byIsFolder(contents);

  routeIdx !== "current" &&
    dispatch(setRoute({ content: content || ROOT, idx: routeIdx }));

  dispatch(
    setContents({
      current: content || null,
      contents,
      files: dividedContents.files || [],
      folders: dividedContents.folders || [],
    })
  );

  return dispatch(getDeletedItems(content));
};

export const deleteContent = (content, current) => async (dispatch) => {
  const client = loaderClient("delete")(`${LIBRARIES_BASE}?softDelete=true`);
  const res = await client({ items: [content.id] })({});
  if (res.error) return "";
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const permanentlyDeleteContent = (content, current) => async (
  dispatch
) => {
  const client = loaderClient("delete")(`${LIBRARIES_BASE}?softDelete=false`);
  const res = await client({ items: [content.id] })({});
  if (res.error) return "";
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const restoreContent = (content, current) => async (dispatch) => {
  const client = loaderClient("patch")(`${LIBRARIES_BASE}/${content.id}`);
  const res = await client({ is_deleted: false })({});
  if (res.error) return "";
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const editContentTitle = (content, title, current) => async (
  dispatch
) => {
  const client = loaderClient("patch")(`${LIBRARIES_BASE}/${content.id}`);
  const res = await client({ title })({});
  if (res.error) return "";
  return dispatch(changeCurFolderByContent(current, "current"));
};

export const addNewFolder = (parentContent, title) => async (dispatch) => {
  const client = loaderClient("post")(LIBRARIES_BASE);
  const res = await client({
    title,
    parent: parentContent && parentContent.id ? parentContent.id : null,
    is_folder: true,
  })({});

  if (res.error) return "";
  return dispatch(changeCurFolderByContent(parentContent, "current"));
};

export const createSingleFile = (current, item, idx) => async (dispatch) => {
  const onProgress = (idx) => (event) => {
    const value = Math.round((100 * event.loaded) / event.total);
    return dispatch(setFileUploadProgerss({ idx, value }));
  };
  dispatch(setFileStatus({ idx, status: ONPROGRESSFILE }));
  const uploadedFile = await uploadService.upload(
    item.file,
    "/filemanager/upload",
    onProgress(idx),
    item.cancelToken
  );
  dispatch(checkCompleteUpload());
  if (!uploadedFile || !uploadedFile.data || uploadedFile.data.error) {
    toast.error(uploadedFile?.data?.message);
    dispatch(setFileStatus({ idx, status: FAILEDFILE }));
    return dispatch(checkCompleteUpload());
  }

  if (item.isRevised) {
    const client = clientNoLoader("patch")(
      `${LIBRARIES_BASE}/${item.revisedFile.id}`
    );
    const res = await client({
      src: uploadedFile.data.message.id,
      version: item.version,
    })({});

    if (res.error || res.status === AXIOSFALIED) {
      toast.error(res.message);
      dispatch(setFileStatus({ idx, status: FAILEDFILE }));
      return dispatch(checkCompleteUpload());
    }

    dispatch(setFileStatus({ idx, status: SUCCESSFILE }));
    return dispatch(checkCompleteUpload());
  } else {
    const client = clientNoLoader("post")(LIBRARIES_BASE);

    const res = await client({
      title: item.name,
      parent: current && current.id ? current.id : null,
      src: uploadedFile.data.message.id,
      is_folder: false,
      version: item.version,
    })({});

    if (res.error || res.status === AXIOSFALIED) {
      toast.error(res.message);
      dispatch(setFileStatus({ idx, status: FAILEDFILE }));
      return dispatch(checkCompleteUpload());
    }
    dispatch(setFileStatus({ idx, status: SUCCESSFILE }));
    return dispatch(checkCompleteUpload());
  }
};

export const createMultiFile = (current) => async (dispatch, getState) => {
  const uploadList = selUploadList(getState());
  const foreachIndexed = R.addIndex(R.forEach);

  dispatch(setUploadStatus(ONUPLOAd));

  foreachIndexed((item, idx) => {
    dispatch(createSingleFile(current, item, idx));
  })(uploadList);
};

export const getContentSetDrawer = (content) => async (dispatch) => {
  const client = loaderClient("get")(`${LIBRARIES_BASE}/${content.id}`);
  const res = await client({})({});
  if (res.error) return "";

  dispatch(setDrawerContent(res.message));
};

export const createFileNewVersion = (file, content, current, version) => async (
  dispatch
) => {
  dispatch(setLoading(true));
  const uploadedFile = await uploadService.upload(file, "/filemanager/upload");
  dispatch(setLoading(false));

  if (uploadedFile.data.error) return "";
  const client = loaderClient("patch")(`${LIBRARIES_BASE}/${content.id}`);

  const res = await client({
    src: uploadedFile.data.message.id,
    version: version,
  })({});
  if (!res || res.error) return "";

  await dispatch(changeCurFolderByContent(current, "current"));
  return dispatch(getContentSetDrawer(content));
};

export const setFromArchive = (content, current, archive) => async (
  dispatch
) => {
  const client = loaderClient("patch")(`${LIBRARIES_BASE}/${content.id}`);

  const res = await client({
    src: archive.src.id,
    version: archive.version,
  })({});

  if (!res || res.error) return "";

  await dispatch(changeCurFolderByContent(current, "current"));
  return dispatch(getContentSetDrawer(content));
};

export const moveContent = () => async (dispatch, getState) => {
  const forCutContent = selCutContent(getState());
  const { current } = selContent(getState());
  const client = loaderClient("patch")(`${LIBRARIES_BASE}/${forCutContent.id}`);
  const res = await client({
    parent: current && current.id ? current.id : null,
  })({});
  if (res.error) return "";
  dispatch(setCutStatus(INITCUT));
  return dispatch(changeCurFolderByContent(current, "current"));
};
